import { Link } from "react-router-dom";
import { MarketingCta } from "../../components/marketing/marketing-cta";
import { MarketingLayout } from "../../components/marketing/marketing-layout";
import { landingContent } from "../../content/marketing/landing";
import { usePageMeta } from "../../hooks/use-page-meta";

export default function LandingPage() {
  usePageMeta(landingContent.metaTitle, landingContent.metaDescription);

  return (
    <MarketingLayout>
      <section className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-4 py-16 text-center md:px-6 md:py-24">
        <h1 className="font-bold font-display text-4xl md:text-5xl">
          {landingContent.title}
        </h1>
        <p className="text-lg text-muted-foreground">
          {landingContent.tagline}
        </p>
        <p className="max-w-2xl text-base">{landingContent.intro}</p>
        <MarketingCta />
      </section>

      <section className="mx-auto max-w-5xl px-4 md:px-6">
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet="/images/marketing/hero-desktop.webp"
            type="image/webp"
          />
          <source
            media="(min-width: 768px)"
            srcSet="/images/marketing/hero-desktop.png"
            type="image/png"
          />
          <source
            srcSet="/images/marketing/hero-mobile.webp"
            type="image/webp"
          />
          {/* biome-ignore lint/nursery/useImageSize: this <picture> swaps between a
          portrait mobile source (780x1688, a real 390x844 phone viewport at
          2x DPR) and a landscape desktop source (2400x1350) at the same
          breakpoint as the CSS below — a single width/height attr pair can't
          describe both, and would reintroduce the exact layout shift this
          rule exists to prevent. The responsive aspect-[390/844]
          md:aspect-[16/9] classes reserve the correct box for each
          breakpoint instead — this MUST match the mobile capture's actual
          aspect ratio (scripts/marketing/capture-hero.mjs's viewport), or
          object-cover silently re-crops the image to the wrong shape. */}
          <img
            alt={landingContent.heroImageAlt}
            className="aspect-[390/844] w-full rounded-lg border border-border object-cover md:aspect-[16/9]"
            loading="eager"
            src="/images/marketing/hero-mobile.png"
          />
        </picture>
      </section>

      <section className="mx-auto flex max-w-5xl flex-col gap-8 px-4 py-16 md:px-6 md:py-24">
        <h2 className="text-center font-bold font-display text-2xl md:text-3xl">
          {landingContent.teaserHeading}
        </h2>
        <div className="grid gap-6 md:grid-cols-3" data-testid="teaser-grid">
          {landingContent.teaserItems.map((item) => (
            <Link
              className="flex flex-col gap-2 rounded-lg border border-border p-6 hover:border-foreground/40"
              key={item.title}
              to={item.href}
            >
              <h3 className="font-semibold text-lg">{item.title}</h3>
              <p className="text-muted-foreground text-sm">
                {item.description}
              </p>
            </Link>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
